/**
 * @fileoverview Arc layout for the forgot-password screen (AR-792)
 * @description Centers the legacy heading/body into the same narrow column and
 * card treatment as the Arc signin. Only rendered when the arc flag is on.
 */

import styled from 'styled-components'
import {
  ARC_BORDER,
  ARC_CARD_RADIUS_PX,
  ARC_CARD_SHADOW,
  ARC_TEXT_MUTED,
} from 'components/ArcAuthPage'

const COLUMN_MAX_WIDTH_PX = 512

export const ArcForgotColumn = styled.main`
  width: 100%;
  max-width: ${COLUMN_MAX_WIDTH_PX}px;
  margin: 0 auto;
  padding: 24px 16px 32px;

  /* Center the legacy heading block and free it from the wide Container */
  .mantine-Container-root {
    max-width: 100%;
    padding: 0;
  }

  h1 {
    text-align: center;
    font-weight: 900;
    letter-spacing: -1.5px;
    line-height: 1.1;
    margin-bottom: 12px;
  }

  h1 + .mantine-Text-root {
    display: block;
    text-align: center;
    font-size: 16px;
    color: ${ARC_TEXT_MUTED};
    line-height: 1.7;
    max-width: 44ch;
    margin: 0 auto;
  }

  /* Breathing room between the copy and the card */
  form {
    margin-top: 28px;
  }

  /* Legacy PaperStyled is 54rem wide; fit it to the column */
  form > div > div {
    width: 100%;
  }

  /* Card mirrors the site .contact-form, like the signin card */
  .mantine-Paper-root {
    border: 1.5px solid ${ARC_BORDER};
    border-radius: ${ARC_CARD_RADIUS_PX}px;
    box-shadow: ${ARC_CARD_SHADOW};
    padding: 28px 36px;

    @media (max-width: 500px) {
      padding: 28px 24px;
    }
  }

  /* Full-width primary, matching the signin card hierarchy */
  .mantine-Paper-root button[type='submit'] {
    width: 100%;
    margin-top: 28px;
  }
`
